const validate = ({
  descripcion = '', puntajeTotal = 0, fechaEntrega = '', tipoTarea = { value: 0, label: '-' },
}) => {
  const errors = {};

  if (!descripcion) {
    errors.descripcion = 'Debe ingresar un valor';
  }

  if (!puntajeTotal || puntajeTotal <= 0) {
    errors.puntajeTotal = 'Debe ingresar un valor';
  }

  if (!tipoTarea || !tipoTarea.value) {
    errors.tipoTarea = 'Debe ingresar un tipo de tarea';
  }

  if (!fechaEntrega) {
    errors.fechaEntrega = 'Debe ingresar una fecha';
  }

  if (!fechaEntrega) {
    errors.fechaEntrega = 'Debe ingresar una fecha';
  }

  return errors;
};

export default validate;
